import { CPP } from "../../types/cpp";
import { CPP_LOADING, CPP_SESSION, LOAD_CPP, SET_CPP } from "../constants";

const initial_state = {
  loading: false,
  current: {
    // id: 1,
    // key: "bgc",
    // title: "Berkshire Gas Company",
    // emailDomain: "berkshiregas.com",
    // chatBotKey: "123-123-123-123",
  },
  list: [] as CPP[],
};

interface stateOptions {
  type: string;
  payload?: any;
}

export default function UserReducer(state = initial_state, { type, payload }: stateOptions) {
  switch (type) {
    case CPP_LOADING:
      return {
        ...state,
        loading: true,
      };

    case LOAD_CPP:
      return {
        ...state,
        list: payload,
      };

    case SET_CPP:
      sessionStorage.setItem(CPP_SESSION, payload.emailDomain);

      return {
        ...state,
        loading: false,
        current: payload,
      };

    default:
      return state;
  }
}
